export default (selectedCheckbox, item, children, cargoIndex, stopIndex, deliveryIndex, initialNode) => {
  const selectedIds = selectedCheckbox.map((item) => item.id || item.data.id);

  item.selected = !item.selected;
  if (selectedIds.includes(item.data.id)) {
    selectedCheckbox = selectedCheckbox.filter((itemSelected) => itemSelected.id !== item.data.id);

    if (children) {
      children.map((itemC) => {
        itemC.selected = !itemC.selected;
        selectedCheckbox = selectedCheckbox.filter((itemN) => itemN.id !== itemC.data.id);
        if (itemC.children) {
          itemC.children.map((itemChildren) => {
            if (itemChildren.isFinishDelivery !== undefined && !itemChildren.isFinishDelivery) {
              itemChildren.selected = false;
            } else {
              itemChildren.selected = !itemChildren.selected;
              selectedCheckbox = selectedCheckbox.filter((itemN) => itemN.id !== itemChildren.data.id);

              if (itemChildren.children) {
                itemChildren.children.map((childrenOfChildren) => {
                  childrenOfChildren.selected = !childrenOfChildren.selected;
                  selectedCheckbox = selectedCheckbox.filter((itemN) => itemN.id !== childrenOfChildren.data.id);
                  if (childrenOfChildren.children) {
                    childrenOfChildren.children.map((childrenOfChildren2) => {
                      childrenOfChildren2.selected = !childrenOfChildren2.selected;
                      selectedCheckbox = selectedCheckbox.filter((itemN) => itemN.id !== childrenOfChildren2.data.id);
                    });
                  }
                });
              }
            }
          });
        }
      });
    }

    if (item.type === 'Cargo' && initialNode.type === 'Shipments' && initialNode.selected) {
      initialNode.selected = false;
      selectedCheckbox = selectedCheckbox.filter((itemN) => itemN.id !== initialNode.data.id);
    }

    if (item.type === 'Stops' && initialNode.type === 'Shipments' && initialNode.children[cargoIndex].selected) {
      initialNode.children[cargoIndex].selected = false;
      selectedCheckbox = selectedCheckbox.filter((itemN) => itemN.id !== initialNode.children[cargoIndex].data.id);
      if (initialNode.selected) {
        initialNode.selected = false;
        selectedCheckbox = selectedCheckbox.filter((itemN) => itemN.id !== initialNode.data.id);
      }
    }

    if (
      item.type === 'Deliveries' &&
      initialNode.type === 'Shipments' &&
      initialNode.children[cargoIndex].children[stopIndex].selected
    ) {
      initialNode.children[cargoIndex].children[stopIndex].selected = false;
      selectedCheckbox = selectedCheckbox.filter(
        (itemN) => itemN.id !== initialNode.children[cargoIndex].children[stopIndex].data.id
      );
      if (initialNode.children[cargoIndex].selected) {
        initialNode.children[cargoIndex].selected = false;
        selectedCheckbox = selectedCheckbox.filter((itemN) => itemN.id !== initialNode.children[cargoIndex].data.id);
        if (initialNode.selected) {
          initialNode.selected = false;
          selectedCheckbox = selectedCheckbox.filter((itemN) => itemN.id !== initialNode.data.id);
        }
      }
    }

    if (item.type === 'Deliveries' && initialNode.type === 'Stops' && initialNode.selected) {
      initialNode.selected = false;
      selectedCheckbox = selectedCheckbox.filter((itemN) => itemN.id !== initialNode.data.id);
    }

    if (
      item.type === 'Nfes' &&
      initialNode.type === 'Shipments' &&
      initialNode.children[cargoIndex].children[stopIndex].children[deliveryIndex].selected
    ) {
      initialNode.children[cargoIndex].children[stopIndex].children[deliveryIndex].selected = false;
      selectedCheckbox = selectedCheckbox.filter(
        (itemN) => itemN.id !== initialNode.children[cargoIndex].children[stopIndex].children[deliveryIndex].data.id
      );
      if (initialNode.children[cargoIndex].children[stopIndex].selected) {
        initialNode.children[cargoIndex].children[stopIndex].selected = false;
        selectedCheckbox = selectedCheckbox.filter(
          (itemN) => itemN.id !== initialNode.children[cargoIndex].children[stopIndex].data.id
        );
        if (initialNode.children[cargoIndex].selected) {
          initialNode.children[cargoIndex].selected = false;
          selectedCheckbox = selectedCheckbox.filter((itemN) => itemN.id !== initialNode.children[cargoIndex].data.id);
          if (initialNode.selected) {
            initialNode.selected = false;
            selectedCheckbox = selectedCheckbox.filter((itemN) => itemN.id !== initialNode.data.id);
          }
        }
      }
    }
    if (item.type === 'Nfes' && initialNode.type === 'Stops' && initialNode.children[deliveryIndex].selected) {
      initialNode.children[deliveryIndex].selected = false;
      selectedCheckbox = selectedCheckbox.filter((itemN) => itemN.id !== initialNode.children[deliveryIndex].data.id);
      if (initialNode.selected) {
        initialNode.selected = false;
        selectedCheckbox = selectedCheckbox.filter((itemN) => itemN.id !== initialNode.data.id);
      }
    }

    if (item.type === 'DeliveryShipper') {
      if (item.children.some((item) => item === true)) {
        item.hasSelectedChildren = true;
      } else {
        item.hasSelectedChildren = false;
      }

      if (item.children.every((item) => !item.selected)) {
        item.hasSelectedChildren = false;
      }
    }

    if (item.type === 'NfeShipper') {
      if (initialNode.selected) {
        initialNode.selected = false;
        selectedCheckbox = selectedCheckbox.filter((itemN) => itemN.id !== initialNode.data.id);
      }
    }

    if (item.type === 'AccountsPayableFather') {
      if (item.children.some((item) => item === true)) {
        item.hasSelectedChildren = true;
      } else {
        selectedCheckbox = [];
      }

      if (item.children.every((item) => !item.selected)) {
        item.hasSelectedChildren = false;
      }
    }
    if (item.type === 'AccountsPayable') {
      const childrenSelected = initialNode.children.map((item) => item.selected);
      if (!childrenSelected.some((item) => item === true)) {
        initialNode.hasSelectedChildren = false;
        selectedCheckbox = [];
      }
      if (initialNode.selected) {
        initialNode.selected = false;
        selectedCheckbox = selectedCheckbox.filter((itemN) => itemN.id !== initialNode.data.id);
      }
    }

    if (item.type === 'AccountsPayableTranshipmentFather') {
      if (item.children.some((item) => item === true)) {
        item.hasSelectedChildren = true;
      } else {
        selectedCheckbox = [];
      }

      if (item.children.every((item) => !item.selected)) {
        item.hasSelectedChildren = false;
      }
    }
    if (item.type === 'AccountsPayableTranshipmentCargo') {
      const childrenSelected = initialNode.children.map((item) => item.selected);
      if (!childrenSelected.some((item) => item === true)) {
        const isCargoChildSelected = initialNode.children.some((cargo) => cargo.hasSelectedChildren);

        if (!isCargoChildSelected) {
          initialNode.hasSelectedChildren = false;
          selectedCheckbox = [];
        }
      }
      if (initialNode.selected) {
        initialNode.selected = false;
        selectedCheckbox = selectedCheckbox.filter((itemN) => itemN.id !== initialNode.data.id);
      }
    }
    if (item.type === 'AccountsPayableTranshipmentStop') {
      const childrenChildrenSelected = initialNode.children[cargoIndex].children.map((item) => item.selected);

      if (!childrenChildrenSelected.some((item) => item === true)) {
        initialNode.children[cargoIndex].hasSelectedChildren = false;
      }

      if (initialNode.children[cargoIndex].selected) {
        initialNode.children[cargoIndex].selected = false;
        selectedCheckbox = selectedCheckbox.filter((itemN) => itemN.id !== initialNode.children[cargoIndex].data.id);
        if (initialNode.selected) {
          initialNode.selected = false;
          selectedCheckbox = selectedCheckbox.filter((itemN) => itemN.id !== initialNode.data.id);
        }
      }
    }

    if (item.type === 'QuickNfe') {
      initialNode.selected = false;
      selectedCheckbox = selectedCheckbox.filter((itemN) => itemN.id !== initialNode.data.id);
    }

    if (item.type === 'AccountsReceivableShipperFather') {
      if (item.children.some((item) => item === true)) {
        item.hasSelectedChildren = true;
      } else {
        selectedCheckbox = [];
      }

      if (item.children.every((item) => !item.selected)) {
        item.hasSelectedChildren = false;
      }
    }

    if (item.type === 'AccountsReceivableShipperCargo') {
      const hasDeliverySelectedInSomeCargo = initialNode.children.map((cargo) => {
        return cargo.selected || cargo.children.some((delivery) => delivery.selected);
      });

      if (hasDeliverySelectedInSomeCargo.every((item) => !item)) {
        initialNode.hasSelectedChildren = false;
      }

      if (initialNode.selected) {
        initialNode.selected = false;
        selectedCheckbox = selectedCheckbox.filter((itemN) => itemN.id !== initialNode.data.id);
      }
    }

    if (item.type === 'AccountsReceivableShipperDelivery') {
      const hasDeliverySelectedInSomeCargo = initialNode.children.map((cargo) => {
        return cargo.selected || cargo.children.some((delivery) => delivery.selected);
      });

      if (hasDeliverySelectedInSomeCargo.every((item) => !item)) {
        initialNode.hasSelectedChildren = false;
      }

      if (initialNode.children[cargoIndex].selected) {
        initialNode.children[cargoIndex].selected = false;
        selectedCheckbox = selectedCheckbox.filter((itemN) => itemN.id !== initialNode.children[cargoIndex].data.id);
        if (initialNode.selected) {
          initialNode.selected = false;
          selectedCheckbox = selectedCheckbox.filter((itemN) => itemN.id !== initialNode.data.id);
        }
      }
    }
  } else {
    selectedCheckbox.push(item.data);
    if (children) {
      children.map((itemC) => {
        itemC.selected = true;
        if (!selectedCheckbox.includes(itemC.data)) {
          selectedCheckbox.push(itemC.data);
        }
        if (itemC.children) {
          itemC.children.map((itemChildren) => {
            if (itemChildren.isFinishDelivery !== undefined && !itemChildren.isFinishDelivery) {
              itemChildren.selected = false;
            } else {
              itemChildren.selected = true;
              if (!selectedCheckbox.includes(itemChildren.data)) {
                selectedCheckbox.push(itemChildren.data);
              }
              if (itemChildren.children) {
                itemChildren.children.map((childrenOfChildren) => {
                  childrenOfChildren.selected = true;
                  if (!selectedCheckbox.includes(childrenOfChildren.data)) {
                    selectedCheckbox.push(childrenOfChildren.data);
                  }
                  if (childrenOfChildren.children) {
                    childrenOfChildren.children.map((childrenOfChildren2) => {
                      childrenOfChildren2.selected = true;
                      if (!selectedCheckbox.includes(childrenOfChildren2.data)) {
                        selectedCheckbox.push(childrenOfChildren2.data);
                      }
                    });
                  }
                });
              }
            }
          });
        }
      });
    }

    if (item.type === 'NfeShipper') {
      if (initialNode.children.every((item) => item.selected)) {
        initialNode.selected = true;
        selectedCheckbox.push(initialNode.data);
      }
    }

    if (item.type === 'Cargo') {
      if (initialNode.type === 'Shipments') {
        if (initialNode.children.every((item) => item.selected)) {
          initialNode.selected = true;
          selectedCheckbox.push(initialNode.data);
        }
      }
    }

    if (item.type === 'Stops') {
      if (initialNode.type === 'Shipments') {
        if (initialNode.children[cargoIndex].children.every((item) => item.selected)) {
          initialNode.children[cargoIndex].selected = true;
          selectedCheckbox.push(initialNode.children[cargoIndex].data);
          if (initialNode.children.every((item) => item.selected)) {
            initialNode.selected = true;
            selectedCheckbox.push(initialNode.data);
          }
        }
      }
    }

    if (item.type === 'Deliveries') {
      if (initialNode.type === 'Shipments') {
        if (initialNode.children[cargoIndex].children[stopIndex].children.every((item) => item.selected)) {
          initialNode.children[cargoIndex].children[stopIndex].selected = true;
          selectedCheckbox.push(initialNode.children[cargoIndex].children[stopIndex].data);
          if (initialNode.children[cargoIndex].children.every((item) => item.selected)) {
            initialNode.children[cargoIndex].selected = true;
            selectedCheckbox.push(initialNode.children[cargoIndex].data);
            if (initialNode.children.every((item) => item.selected)) {
              initialNode.selected = true;
              selectedCheckbox.push(initialNode.data);
            }
          }
        }
      }
      if (initialNode.type === 'Stops') {
        if (initialNode.children.every((item) => item.selected)) {
          initialNode.selected = true;
          selectedCheckbox.push(initialNode.data);
        }
      }
    }

    if (item.type === 'Nfes') {
      if (initialNode.type === 'Shipments') {
        if (
          initialNode.children[cargoIndex].children[stopIndex].children[deliveryIndex].children.every(
            (item) => item.selected
          )
        ) {
          initialNode.children[cargoIndex].children[stopIndex].children[deliveryIndex].selected = true;
          selectedCheckbox.push(initialNode.children[cargoIndex].children[stopIndex].children[deliveryIndex].data);
          if (initialNode.children[cargoIndex].children[stopIndex].children.every((item) => item.selected)) {
            initialNode.children[cargoIndex].children[stopIndex].selected = true;
            selectedCheckbox.push(initialNode.children[cargoIndex].children[stopIndex].data);
            if (initialNode.children[cargoIndex].children.every((item) => item.selected)) {
              initialNode.children[cargoIndex].selected = true;
              selectedCheckbox.push(initialNode.children[cargoIndex].data);
              if (initialNode.children.every((item) => item.selected)) {
                initialNode.selected = true;
                selectedCheckbox.push(initialNode.data);
              }
            }
          }
        }
      }
      if (initialNode.type === 'Stops') {
        if (initialNode.children[deliveryIndex].children.every((item) => item.selected)) {
          initialNode.children[deliveryIndex].selected = true;
          selectedCheckbox.push(initialNode.children[deliveryIndex].data);
          if (initialNode.children.every((item) => item.selected)) {
            initialNode.selected = true;
            selectedCheckbox.push(initialNode.data);
          }
        }
      }
    }

    if (item.type === 'AccountsPayableFather') {
      item.hasSelectedChildren = item.children.some((item) => item.selected) && item.open;
      if (!item.open) {
        item.hasSelectedChildren = !item.hasSelectedChildren;
      }
      if (!item.hasSelectedChildren && item.open) {
        selectedCheckbox = [];
        item.children.map((element) => {
          return (element.selected = false);
        });
      }
    }

    if (item.type === 'AccountsPayable') {
      initialNode.hasSelectedChildren = true;
      if (initialNode.children.every((item) => item.selected)) {
        initialNode.selected = true;
        selectedCheckbox.push(initialNode);
      }
    }

    if (item.type === 'AccountsPayableTranshipmentFather') {
      item.hasSelectedChildren = item.children.some((item) => item.selected) && item.open;
      if (!item.open) {
        item.hasSelectedChildren = !item.hasSelectedChildren;
      }
      if (!item.hasSelectedChildren && item.open) {
        selectedCheckbox = [];
        item.children.map((element) => {
          return (element.selected = false);
        });
      }
    }

    if (item.type === 'AccountsPayableTranshipmentCargo') {
      initialNode.hasSelectedChildren = true;
      if (initialNode.children.every((item) => item.selected)) {
        initialNode.selected = true;
        selectedCheckbox.push(initialNode.data);
      }
    }

    if (item.type === 'AccountsPayableTranshipmentStop') {
      initialNode.hasSelectedChildren = true;
      if (initialNode.children.every((item) => item.selected)) {
        initialNode.selected = true;
        selectedCheckbox.push(initialNode);
      }
      initialNode.children[cargoIndex].hasSelectedChildren = true;
      if (initialNode.children[cargoIndex].children.every((item) => item.selected)) {
        initialNode.children[cargoIndex].selected = true;
        selectedCheckbox.push(initialNode.children[cargoIndex].data);
      }

      if (initialNode.children.every((item) => item.selected)) {
        initialNode.selected = true;
        selectedCheckbox.push(initialNode.data);
      }
    }
    if (item.type === 'QuickNfe') {
      if (initialNode.children.every((item) => item.selected)) {
        initialNode.selected = true;
        selectedCheckbox.push(initialNode.data);
      }
    }

    if (item.type === 'AccountsReceivableShipperFather') {
      item.hasSelectedChildren = item.children.some((item) => item.selected) && item.open;
      if (!item.open) {
        item.hasSelectedChildren = !item.hasSelectedChildren;
      }
      if (!item.hasSelectedChildren && item.open) {
        selectedCheckbox = [];
        item.children.map((element) => {
          return (element.selected = false);
        });
      }
    }

    if (item.type === 'AccountsReceivableShipperCargo') {
      initialNode.hasSelectedChildren = true;
      if (initialNode.children.every((item) => item.selected)) {
        initialNode.selected = true;
        selectedCheckbox.push(initialNode.data);
      }
    }

    if (item.type === 'AccountsReceivableShipperDelivery') {
      initialNode.hasSelectedChildren = true;

      if (initialNode.children[cargoIndex].children.every((item) => item.selected)) {
        initialNode.children[cargoIndex].selected = true;
        selectedCheckbox.push(initialNode.children[cargoIndex].data);
      }

      if (initialNode.children.every((item) => item.selected)) {
        initialNode.selected = true;
        selectedCheckbox.push(initialNode.data);
      }
    }
  }

  return selectedCheckbox;
};
